var map = {
	"./brl.png": 8495,
	"./da.png": 778,
	"./de.png": 3374,
	"./el.png": 8980,
	"./en.png": 8902,
	"./es.png": 275,
	"./fr.png": 3999,
	"./gbp.png": 5458,
	"./hu.png": 4266,
	"./idr.png": 5816,
	"./inr.png": 2330,
	"./it.png": 4456,
	"./ja.png": 2040,
	"./jp.png": 2193,
	"./pl.png": 6771,
	"./pt.png": 3419,
	"./ru.png": 1092,
	"./sv.png": 2168,
	"./tr.png": 1809,
	"./zh.png": 1481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7900;